// extracted by mini-css-extract-plugin
module.exports = {"productHeader":"Product_productHeader__2l52t","product":"Product_product__4Z28z"};